module.exports = __webpack_public_path__ + "img/hk.acefbea7.png";